import { Button, Container, Eyebrow, Lead, Section, SectionTitle } from '@vcn/ui'
import { useContent } from '../content'

export function FinalCta() {
  const { finalCta } = useContent()

  return (
    <Section id="kontakt" className="scroll-mt-20 text-center">
      <Container>
        <Eyebrow>{finalCta.eyebrow}</Eyebrow>

        <SectionTitle className="mt-4">
          {finalCta.title.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </SectionTitle>

        <Lead className="mx-auto mt-6 max-w-xl">{finalCta.body}</Lead>

        <Button href={finalCta.cta.href} className="mt-10">
          {finalCta.cta.label}
        </Button>
      </Container>
    </Section>
  )
}
